import React, { useState } from 'react';
import { Card, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Table from '../../Table';
import { headTbl } from '../../../data/tables';
import classNames from 'classnames';
import moment from 'moment';
import ChangeConfirmation from '../../ui/ChangeConfirmation';
import Confirmation from '../../ui/Confirmation';

const ListSolicitudes = ({ list, getInfo, accesos }) => {
    const [show, setShow] = useState(false);
    const [showd, setShowd] = useState(false);
    const [info, setInfo] = useState({});
    const [infoD, setInfoD] = useState({});
    const { sol_acept, sol_deny, sol_del } = accesos;
    const showMod = (id, status, className) => {
        setInfo({
            ...info,
            body: `Esta segur@ que desea ${status === 'RECHAZADA' ? 'rechazar' : 'aceptar'} la solicitud`,
            endpoint: `nominas/solicitud`,
            data: { id, status, className },
        });
        setShow(true);
    };

    const ActionColumn = ({ row }) => {
        return (
            <>
                {sol_acept && (
                    <OverlayTrigger
                        className="action-icon "
                        placement="left"
                        overlay={<Tooltip id="overlay-example">Aceptar solicitud</Tooltip>}>
                        <i
                            className="mdi mdi-calendar-check fs-3  text-success"
                            onClick={() => showMod(row.original.id, 'ACEPTADA', 'bg-success')}></i>
                    </OverlayTrigger>
                )}
                {sol_deny && (
                    <OverlayTrigger
                        placement="left"
                        overlay={<Tooltip id="overlay-example">Denegar solicitud</Tooltip>}>
                        <i
                            className="mdi mdi-calendar-remove-outline fs-3 mx-2 text-warning"
                            onClick={() => showMod(row.original.id, 'RECHAZADA', 'bg-danger')}></i>
                    </OverlayTrigger>
                )}
                {sol_del && (
                    <OverlayTrigger
                        placement="left"
                        overlay={<Tooltip id="overlay-example">Eliminar solicitud</Tooltip>}>
                        <i
                            className="mdi mdi-delete fs-3 ml-2 text-danger"
                            onClick={() => onRemoveEvent(row.original.id)}></i>
                    </OverlayTrigger>
                )}
            </>
        );
    };
    const StatusColumn = ({ row }) => {
        return (
            <>
                <span
                    className={classNames('badge', {
                        'bg-warning': row.original.status === 'PENDIENTE',
                        'bg-success': row.original.status === 'ACEPTADA',
                        'bg-danger': row.original.status === 'RECHAZADA',
                    })}>
                    {row.original.status}
                </span>
            </>
        );
    };
    const PeriodColumn = ({ row }) => {
        return (
            <>
                <span className="mdi mdi-calendar-collapse-horizontal"></span>
                {moment(row.original.start).isValid() ? moment(row.original.start).format('YYYY-MM-DD') : ''}
                {moment(row.original.start).isValid() && moment(row.original.end).isValid() ? ' --> ' : ''}
                {moment(row.original.end).isValid() ? moment(row.original.end).format('YYYY-MM-DD') : ''}
            </>
        );
    };
    const columns = [
        {
            Header: 'Id',
            accessor: 'id',
            sort: true,
        },

        {
            Header: 'Concepto',
            accessor: 'title',
            sort: true,
        },
        {
            Header: 'Periodo',
            accessor: 'start',
            sort: true,
            Cell: PeriodColumn,
        },
        {
            Header: 'Estado',
            accessor: 'status',
            sort: true,
            Cell: StatusColumn,
        },

        {
            Header: 'Acción',
            accessor: 'action',
            sort: false,
            classes: 'table-action',
            Cell: ActionColumn,
        },
    ];

    const sizePerPageList = headTbl(list.length);
    const onRemoveEvent = async (id) => {
        setInfoD({ id, type: 'EVENTO' });
        setShowd(true);
    };
    return (
        <Card className="p-3">
            <div className="d-flex">
                <h4 className="header-title mb-1">SOLICITUDES DE VACACIONES</h4>
            </div>

            <Table
                columns={columns}
                data={list}
                pageSize={25}
                sizePerPageList={sizePerPageList}
                isSortable={true}
                pagination={true}
                isSearchable={true}
                searchBoxClass="mb-2"
            />

            <ChangeConfirmation show={show} onClose={() => setShow(false)} info={info} callBk={getInfo} />
            <Confirmation show={showd} toggle={() => setShowd(false)} info={infoD} callBk={getInfo} />
        </Card>
    );
};

export default ListSolicitudes;
